export default __webpack_public_path__ + "static/media/iconodos.db8982d3.svg";